import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Users, BookOpen, LogOut, Plus, Settings } from 'lucide-react';
import axios from 'axios';

export default function AdminDashboard() {
  const { token, API, logout } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/admin/stats`, {
          headers: { Authorization: `Bearer ${token}` }, withCredentials: true
        });
        setStats(res.data);
      } catch { /* ignore */ }
    };
    fetch();
  }, [API, token]);

  const handleLogout = async () => { await logout(); navigate('/', { replace: true }); };

  return (
    <div className="min-h-screen" style={{ background: '#FFF8F0' }}>
      <div className="px-4 pt-4 pb-2 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold" style={{ color: '#1B4F8A' }}>Admin Dashboard</h1>
          <p className="text-xs font-semibold" style={{ color: '#8B7355' }}>MathTopper Control Panel</p>
        </div>
        <button data-testid="admin-logout-btn" onClick={handleLogout} className="p-2" style={{ color: '#8B7355' }}>
          <LogOut size={20} />
        </button>
      </div>

      <div className="px-4 space-y-4 pb-8">
        {/* Stats */}
        <div className="grid grid-cols-2 gap-3" data-testid="admin-stats">
          {[
            { label: 'Total Students', value: stats?.total_students || 0, color: '#1B4F8A', icon: '🎓' },
            { label: 'Active Today', value: stats?.active_today || 0, color: '#06D6A0', icon: '📊' },
            { label: 'Questions', value: stats?.total_questions || 0, color: '#FF6B35', icon: '📝' },
            { label: 'Paid Subs', value: stats?.active_subscriptions || 0, color: '#FFD23F', icon: '💰' },
          ].map((s, i) => (
            <div key={i} className="bg-white border-2 rounded-2xl p-4 text-center" style={{ borderColor: '#E5DACE' }}>
              <div className="text-2xl mb-1">{s.icon}</div>
              <p className="text-2xl font-black" style={{ color: s.color }}>{s.value}</p>
              <p className="text-xs font-semibold" style={{ color: '#8B7355' }}>{s.label}</p>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="space-y-3" data-testid="admin-actions">
          <button data-testid="config-centre-btn" onClick={() => navigate('/admin/config')}
            className="btn-press w-full bg-white border-2 rounded-2xl p-4 flex items-center gap-4 text-left"
            style={{ borderColor: '#E5DACE', boxShadow: '0 3px 0 #E5DACE' }}>
            <Settings size={22} color="#8338EC" />
            <div>
              <p className="text-sm font-extrabold" style={{ color: '#1B4F8A' }}>Configuration Centre</p>
              <p className="text-xs font-semibold" style={{ color: '#8B7355' }}>Manage classes, chapters, question types, badges, XP rules</p>
            </div>
          </button>

          <button data-testid="manage-questions-btn" onClick={() => navigate('/admin/questions')}
            className="btn-press w-full bg-white border-2 rounded-2xl p-4 flex items-center gap-4 text-left"
            style={{ borderColor: '#E5DACE', boxShadow: '0 3px 0 #E5DACE' }}>
            <BookOpen size={22} color="#FF6B35" />
            <div>
              <p className="text-sm font-extrabold" style={{ color: '#1B4F8A' }}>Manage Questions</p>
              <p className="text-xs font-semibold" style={{ color: '#8B7355' }}>Add, edit, or delete questions</p>
            </div>
          </button>

          <button data-testid="manage-users-btn" onClick={() => navigate('/admin/users')}
            className="btn-press w-full bg-white border-2 rounded-2xl p-4 flex items-center gap-4 text-left"
            style={{ borderColor: '#E5DACE', boxShadow: '0 3px 0 #E5DACE' }}>
            <Users size={22} color="#1B4F8A" />
            <div>
              <p className="text-sm font-extrabold" style={{ color: '#1B4F8A' }}>Manage Users</p>
              <p className="text-xs font-semibold" style={{ color: '#8B7355' }}>View all users and their progress</p>
            </div>
          </button>

          <button data-testid="seed-data-btn" onClick={async () => {
            try {
              const res = await axios.get(`${API}/seed/auto`);
              alert(res.data.message);
            } catch { alert('Seed failed'); }
          }}
            className="btn-press w-full bg-white border-2 rounded-2xl p-4 flex items-center gap-4 text-left"
            style={{ borderColor: '#E5DACE', boxShadow: '0 3px 0 #E5DACE' }}>
            <Plus size={22} color="#06D6A0" />
            <div>
              <p className="text-sm font-extrabold" style={{ color: '#1B4F8A' }}>Seed Sample Questions</p>
              <p className="text-xs font-semibold" style={{ color: '#8B7355' }}>Load CBSE questions for all classes</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
